import { Component } from '@angular/core';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-fiscale-positie',
  templateUrl: './fiscale-positie.component.html',
  styleUrls: ['./fiscale-positie.component.scss']
})
export class FiscalePositieComponent {}
